import React from 'react';
import { Card, CardTitle, CardBody, CardText, CardHeader } from 'reactstrap'; 
import SkeletonImage from '../SkeletonImage';
import MaterialGrid from '../MaterialGrid';

export function RenderTwoStar({lore, unitImage, unitEvo}) {
    return (
        <React.Fragment>
            <Card className="gs-card gs-unit-lore__card">
                <CardTitle>
                    <center>
                        <Card className="gs-surface gs-unit-lore__evo-card">
                            <CardHeader className="gs-unit-lore__evo-header">
                                <h2>Evolution Materials</h2>
                            </CardHeader>
                            <CardBody>
                                <RenderEvolution mat={unitEvo.evo23} />
                            </CardBody>
                        </Card>
                    </center>
                    
                </CardTitle>
                <CardBody className="gs-card-body">
                    <CardText>
                        <RenderLore lore={lore} />
                    </CardText>
                </CardBody>
                <RenderDetail detail={unitImage.detail2} />
            </Card>
        </React.Fragment>
    )
}

export function RenderThreeStar({lore, unitImage, unitEvo}) {
    return (
        <React.Fragment>
            <Card className="gs-card gs-unit-lore__card">
                <CardTitle>
                    <center>
                        <Card className="gs-surface gs-unit-lore__evo-card">
                            <CardHeader className="gs-unit-lore__evo-header">
                                <h2>Evolution Materials</h2>
                            </CardHeader>
                            <CardBody>
                                <RenderEvolution mat={unitEvo.evo34} />
                            </CardBody>
                        </Card>
                    </center>
                </CardTitle>
                <CardBody className="gs-card-body">
                    <CardText>
                        <RenderLore lore={lore} />
                    </CardText>
                </CardBody>
                <RenderDetail detail={unitImage.detail3} />
            </Card>
        </React.Fragment>
    )
}

export function RenderFourStar({lore, unitImage, unitEvo}) {
    return (
        <React.Fragment>
            <Card className="gs-card gs-unit-lore__card">
                <CardTitle>
                    <center>
                        <Card className="gs-surface gs-unit-lore__evo-card">
                            <CardHeader className="gs-unit-lore__evo-header">
                                <h2>Evolution Materials</h2>
                            </CardHeader>
                            <CardBody>
                                <RenderEvolution mat={unitEvo.evo45} />
                            </CardBody>
                        </Card>
                    </center>
                </CardTitle>
                <CardBody className="gs-card-body">
                    <CardText>
                        <RenderLore lore={lore} />
                    </CardText>
                </CardBody>
                <RenderDetail detail={unitImage.detail4} />    
            </Card>
        </React.Fragment>
    )
}

export function RenderFiveStar({lore, unitImage, unitEvo = false}) {
    if(unitEvo.evo5awk){
        return (
            <React.Fragment>
                <Card className="gs-card gs-unit-lore__card">
                    <CardTitle>
                        <center>
                            <Card className="gs-surface gs-unit-lore__evo-card">
                                <CardHeader className="gs-unit-lore__evo-header">
                                    <h2>Evolution Materials</h2>
                                </CardHeader>
                                <CardBody>
                                    <RenderEvolution mat={unitEvo.evo5awk} />
                                </CardBody>
                            </Card>
                        </center>
                    </CardTitle>
                    <CardBody className="gs-card-body">
                        <CardText>
                            <RenderLore lore={lore} />
                        </CardText>
                    </CardBody>
                    <RenderDetail detail={unitImage.detail5} />   
                </Card>
            </React.Fragment>
        )
    }

    return (
        <React.Fragment>
            <Card className="gs-card gs-unit-lore__card">
                <CardTitle>
                    <p className="gs-unit-lore__max-note">This unit has reached max evolution</p>
                </CardTitle>
                <CardBody className="gs-card-body">
                    <RenderLore lore={lore} />
                </CardBody>
                <RenderDetail detail={unitImage.detail5} />
            </Card>
        </React.Fragment>
    )
}

export function RenderAwaken({lore, unitImage, unitEvo}) {
    if(unitImage.detailsuper) {
        return (
            <React.Fragment>
                <Card className="gs-card gs-unit-lore__card">
                    <CardTitle>
                        <center>
                            <Card className="gs-surface gs-unit-lore__evo-card">
                                <CardHeader className="gs-unit-lore__evo-header">
                                    <h2>Evolution Materials</h2>
                                </CardHeader>
                                <CardBody>
                                    <RenderEvolution mat={unitEvo.evoawksuper} />
                                </CardBody>
                            </Card>
                        </center>
                    </CardTitle>
                    <CardBody className="gs-card-body">
                        <CardText>
                            <RenderLore lore={lore} />
                        </CardText>
                    </CardBody>
                    <RenderDetail detail={unitImage.detailawk} />   
                </Card>
            </React.Fragment>
        )
    }
    else {
        return (
            <React.Fragment>
                <Card className="gs-card gs-unit-lore__card">
                    <CardTitle>
                        <p className="gs-unit-lore__max-note">This unit has reached max evolution</p>
                    </CardTitle>
                    <CardBody className="gs-card-body">
                        <div className="gs-unit-lore__body"><p>{lore}</p></div>
                    </CardBody>
                    <RenderDetail detail={unitImage.detailawk} />
                </Card>
            </React.Fragment>
        )
    }
    
}

export function RenderSuper({lore, unitImage}) {
    return (
        <React.Fragment>
            <Card className="gs-card gs-unit-lore__card">
                <CardTitle>
                    <p className="gs-unit-lore__max-note">This unit has reached max evolution</p>
                </CardTitle>
                <CardBody className="gs-card-body">
                    <RenderLore lore={lore} />
                </CardBody>
                <RenderDetail detail={unitImage.detailsuper} />
            </Card>
        </React.Fragment>
    )
}

const RenderEvolution = ({ mat }) => {
    if (!mat) {
        return null;
    }

    return (
        <div className="gs-unit-table-scroll gs-unit-table-scroll--mats">
            <MaterialGrid mat={mat} altFallback="Evolution material" />
        </div>
    );
}

const RenderLore = ({ lore }) => {
    return (
        <div className="gs-unit-lore__body">
            <p>{lore}</p>
        </div>
    )
}

const RenderDetail = ({ detail }) => {
    return (
        <div className="gs-unit-detail-art">
            <SkeletonImage
                src={detail}
                alt=""
                className="gs-unit-detail-art__img"
                frameClassName="gs-skeleton-frame--detail"
                loading="lazy"
            />
        </div>
    )
}
